<template>
  <transition name="fade">
    <div styleName="wrapper" class="fade-wp" v-show="show">
      <div styleName="inner-wp">
        <div styleName="content_header">
          <span styleName="header_icon">
            <i></i>{{ $t('set') }}
          </span>
          <span styleName="close_btn" @click="close"></span>
        </div>
        <div styleName="content_body">
          <div styleName="content_body_wrap">
            <div styleName="nav_wrap">
              <span @click="handleClick('micro')" :data-role="currentTabComponent==='micro'">{{$t('microphone')}}</span>
              <span @click="handleClick('camera')" :data-role="currentTabComponent==='camera'">{{$t('camera')}}</span>
              <span @click="handleClick('speaker')" :data-role="currentTabComponent==='speaker'">{{$t('loudspeaker')}}</span>
            </div>
            <div styleName="content_wrap">
              <micro v-if="deviceReady" v-show="currentTabComponent === 'micro'" :show="currentTabComponent === 'micro'" />
              <camera v-if="show" v-show="currentTabComponent === 'camera'" />
              <div v-if="!deviceReady">
                <span v-show="currentTabComponent === 'micro'">{{ $t('noMircophone') }}</span>
                <span v-show="currentTabComponent === 'camera'">{{ $t('noCamera') }}</span>
                <span v-show="currentTabComponent === 'speaker'">{{ $t('noSpeaker') }}</span>
              </div>
              <speaker v-if="deviceReady" v-show="currentTabComponent === 'speaker'" :show="currentTabComponent === 'speaker'" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import styles from './index.scss'
import cssModules from 'vue-css-modules'
import camera from './CameraSetting'
import speaker from './SpeakerSetting'
import micro from './MicroSetting'
import * as types from '../../constants'
import { mapGetters } from 'vuex'
import sensorLog from '@/utils/sensorLog'
export default {
  mixins: [cssModules(styles)],
  components: {
    camera,
    speaker,
    micro
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      content: '',
      currentTabComponent: 'micro'
    }
  },
  computed: {
    ...mapGetters(['deviceLists', 'roomDetail']),
    deviceReady () {
      return this.deviceLists &&
        this.deviceLists.videoList && this.deviceLists.videoList.length &&
        this.deviceLists.audioList && this.deviceLists.audioList.length &&
        this.deviceLists.audioOutputList && this.deviceLists.audioOutputList.length
    },
    selectedDevice () {
      return this.$store.state.mediaInfo.selectedDevice
    },
    selectedVideoDevice () {
      return this.deviceLists.videoList && this.deviceLists.videoList[this.selectedDevice.video]
    },
    selectedAudioDevice () {
      return this.deviceLists.audioList && this.deviceLists.audioList[this.selectedDevice.audio]
    }
  },
  watch: {
    '$store.getters.alertStatus' (status) {
      if (!status) {
        this.currentTabComponent = 'micro' // 关闭之后初始化
      }
    },
    selectedDevice: {
      handler: function () {
        this.getDeviceLog()
      },
      deep: true
    },
    deviceLists: {
      handler: function () {
        this.getDeviceLog()
      },
      deep: true
    }
  },
  methods: {
    handleClick (data) {
      this.currentTabComponent = data
    },
    close () {
      this.$store.commit(types.ALERT_STATUS, false)
      sensorLog.track("hardware_setting_save", types.SENSORLOG.type.SUCCESSED)
    },
    getDeviceLog () {
      if (this.selectedVideoDevice || this.selectedAudioDevice) {
        sensorLog.track("hardware_selected_device", types.SENSORLOG.type.SUCCESSED, JSON.stringify({ video: this.selectedVideoDevice, audio: this.selectedAudioDevice }))
      }
    }
  }
}
</script>

<style>
.fade-wp.fade-enter-active,
.fade-wp.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-wp.fade-enter,
.fade-wp.fade-leave-to {
  opacity: 0;
}
</style>
